import React from "react";
import Marquee1 from "react-fast-marquee";

const Marquee = () => {
  return (
    <>
      <section className="marquee marquee-space z-3 pt-75 pb-90 mb-50">
        <Marquee1
          direction="left"
          className="xb-marquee marquee-left"
          style={{ width: "140vw", overflow: "hidden" }}
        >
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar01.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar02.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar03.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar04.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar05.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar-1.svg" alt="" style={{ height: "80px" }} />
          </div>
          <div className="xb-marquee-item">
            <img
              src="assets/img/brand/mar06.webp"
              style={{ height: "80px" }}
              alt=""
            />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar07.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar08.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar02.webp" alt="" />
          </div>
          
           {/* ---------- */}
          <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-1.webp" alt="" style={{filter: "contrast(0) brightness(100)", height: "120px"}} />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-2.webp" alt="" style={{filter: "contrast(0) brightness(100)" , height: "120px"}}  />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-3.webp" alt="" style={{filter: "contrast(0) brightness(100)", height: "120px"}}  />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-4.webp" alt="" style={{filter: "contrast(0) brightness(100)", height: "120px"}}  />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-5.webp" alt="" style={{filter: "contrast(0) brightness(100)", height: "140px"}}  />
          </div>
           <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-6.webp" alt="" style={{filter: "contrast(0) brightness(100)", height: "140px"}}  />
          </div>

        </Marquee1>
        <div className="clearfix"></div>
        <Marquee1
          direction="right"
          className="xb-marquee marquee-right"
          style={{ width: "140vw", overflow: "hidden" }}
        >
           <div className="xb-marquee-item">
            <img src="assets/img/brand/mar09.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar10.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar11.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar12.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img
              src="assets/img/brand/mar13.webp"
              style={{ height: "100px" }}
              alt=""
            />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar14.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar15.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar16.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar17.svg" alt=""    style={{ height: "80px" }}/>
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar10.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar11.webp" alt="" />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/mar12.webp" alt="" />
          </div>  
          {/* ---------- */}
          <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-1.webp" alt="" style={{filter: "contrast(100) brightness(0)", height: "120px"}} />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-2.webp" alt="" style={{filter: "contrast(100) brightness(0)" , height: "120px"}}  />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-3.webp" alt="" style={{filter: "contrast(100) brightness(0)", height: "120px"}}  />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-4.webp" alt="" style={{filter: "contrast(100) brightness(0)", height: "120px"}}  />
          </div>
          <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-5.webp" alt="" style={{filter: "contrast(100) brightness(0)", height: "140px",}}  />
          </div>
            <div className="xb-marquee-item">
            <img src="assets/img/brand/new/br-6.webp" alt="" style={{filter: "contrast(100) brightness(0)", height: "140px",}}  />
          </div>
          
        </Marquee1>
      </section>
    </>
  );
};

export default Marquee;
